/** Configure Amplify once at startup using this build's environment settings.
 * Analytics stays disabled, matching the existing portal behaviour.
 */
import { Amplify, Auth } from 'aws-amplify';
import axios from 'axios';
import { installSessionAuth } from './webservices/sessionAuth';
import authConfig from './auth-config';

Amplify.configure({
  ...authConfig,
  Analytics: { disabled: true },
});

// Install before React renders; covers legacy services and Flow polling alike.
installSessionAuth(axios, {
  apiUrl: process.env.REACT_APP_API_URL,
  stage: process.env.REACT_APP_ENV,
  currentSession: () => Auth.currentSession(),
});
